/*
 * サブシステム名：
 * 機能名：取引先別帳票出力
 * 帳票カスタマイズ(antz)
 */
import D2BZMD0030 from '@/views/BZM/D2BZMD0030.js'
import date from '@/ddv2.library/date'

export default {
  extends: D2BZMD0030,
  name: 'TorihikisakibetsuOutputForAntz',
  data: () => ({
    dispExcelNm: ''
  }),
  watch: {
    chohyoSbt: function () {
      if (this.chohyoSbt === '0') {
        // 売上明細表
        this.daySbtDisp = true
        this.dayDisp = true
        this.ymDisp = false
        this.yDisp = false
        this.eigyoshoDisp = true
        this.tokuisakiDisp = true
        this.seikyuTomeSbtDisp = true
        this.yoshasakiDisp = false
        this.unchinKakuteiSbtDisp = true
        this.hacchusakiDisp = false
        this.seikyusakiDisp = false
        this.shiharaisakiDisp = false
        this.seikyuTomeSbtReadOnly = false
      } else if (this.chohyoSbt === '1') {
        // 得意先別売上集計表
        this.conditions.daySbt = '01'
        this.daySbtDisp = false
        this.dayDisp = false
        this.ymDisp = true
        this.yDisp = false
        this.eigyoshoDisp = true
        this.tokuisakiDisp = true
        this.seikyuTomeSbtDisp = true
        this.yoshasakiDisp = false
        this.unchinKakuteiSbtDisp = false
        this.hacchusakiDisp = false
        this.seikyusakiDisp = false
        this.shiharaisakiDisp = false
        this.seikyuTomeSbtReadOnly = false
      } else if (this.chohyoSbt === '2') {
        // 得意先別売上日計表
        this.conditions.daySbt = '01'
        this.daySbtDisp = false
        this.dayDisp = false
        this.ymDisp = true
        this.yDisp = false
        this.eigyoshoDisp = true
        this.tokuisakiDisp = true
        this.seikyuTomeSbtDisp = true
        this.yoshasakiDisp = false
        this.unchinKakuteiSbtDisp = false
        this.hacchusakiDisp = false
        this.seikyusakiDisp = false
        this.shiharaisakiDisp = false
        this.seikyuTomeSbtReadOnly = true
      } else if (this.chohyoSbt === '3') {
        // 得意先別年間売上対比表
        this.conditions.daySbt = '01'
        this.daySbtDisp = false
        this.dayDisp = false
        this.ymDisp = false
        this.yDisp = true
        this.eigyoshoDisp = true
        this.tokuisakiDisp = true
        this.seikyuTomeSbtDisp = true
        this.yoshasakiDisp = false
        this.unchinKakuteiSbtDisp = false
        this.hacchusakiDisp = false
        this.seikyusakiDisp = false
        this.shiharaisakiDisp = false
        this.seikyuTomeSbtReadOnly = true
      } else if (this.chohyoSbt === '4') {
        // 傭車先下払明細表
        this.daySbtDisp = true
        this.dayDisp = true
        this.ymDisp = false
        this.yDisp = false
        this.eigyoshoDisp = true
        this.tokuisakiDisp = false
        this.seikyuTomeSbtDisp = true
        this.yoshasakiDisp = true
        this.unchinKakuteiSbtDisp = true
        this.hacchusakiDisp = false
        this.seikyusakiDisp = false
        this.shiharaisakiDisp = false
        this.seikyuTomeSbtReadOnly = false
      } else if (this.chohyoSbt === '5') {
        // 傭車先下払集計表
        this.conditions.daySbt = '01'
        this.daySbtDisp = false
        this.dayDisp = false
        this.ymDisp = true
        this.yDisp = false
        this.eigyoshoDisp = true
        this.tokuisakiDisp = false
        this.seikyuTomeSbtDisp = false
        this.yoshasakiDisp = true
        this.unchinKakuteiSbtDisp = true
        this.hacchusakiDisp = false
        this.seikyusakiDisp = false
        this.shiharaisakiDisp = false
        this.seikyuTomeSbtReadOnly = true
      } else if (this.chohyoSbt === '6') {
        // 取引先別発注明細表
        this.daySbtDisp = false
        this.dayDisp = true
        this.ymDisp = false
        this.yDisp = false
        this.eigyoshoDisp = true
        this.tokuisakiDisp = false
        this.seikyuTomeSbtDisp = false
        this.yoshasakiDisp = false
        this.unchinKakuteiSbtDisp = false
        this.hacchusakiDisp = true
        this.seikyusakiDisp = false
        this.shiharaisakiDisp = false
        this.seikyuTomeSbtReadOnly = true
      } else if (this.chohyoSbt === '7') {
        // 取引先別年間発注対比表
        this.conditions.daySbt = '01'
        this.daySbtDisp = false
        this.dayDisp = false
        this.ymDisp = false
        this.yDisp = true
        this.eigyoshoDisp = true
        this.tokuisakiDisp = false
        this.seikyuTomeSbtDisp = false
        this.yoshasakiDisp = false
        this.unchinKakuteiSbtDisp = false
        this.hacchusakiDisp = true
        this.seikyusakiDisp = false
        this.shiharaisakiDisp = false
        this.seikyuTomeSbtReadOnly = true
      } else if (this.chohyoSbt === '8') {
        // 売掛残高一覧表
        this.conditions.daySbt = '01'
        this.daySbtDisp = false
        this.dayDisp = false
        this.ymDisp = true
        this.yDisp = false
        this.eigyoshoDisp = false
        this.tokuisakiDisp = false
        this.seikyuTomeSbtDisp = false
        this.yoshasakiDisp = false
        this.unchinKakuteiSbtDisp = false
        this.hacchusakiDisp = false
        this.seikyusakiDisp = true
        this.shiharaisakiDisp = false
        this.seikyuTomeSbtReadOnly = true
      } else if (this.chohyoSbt === '9') {
        // 売掛残高推移表
        this.conditions.daySbt = '01'
        this.daySbtDisp = false
        this.dayDisp = false
        this.ymDisp = true
        this.yDisp = false
        this.eigyoshoDisp = false
        this.tokuisakiDisp = false
        this.seikyuTomeSbtDisp = false
        this.yoshasakiDisp = false
        this.unchinKakuteiSbtDisp = false
        this.hacchusakiDisp = false
        this.seikyusakiDisp = true
        this.shiharaisakiDisp = false
        this.seikyuTomeSbtReadOnly = true
      } else if (this.chohyoSbt === '10') {
        // 買掛残高一覧表
        this.conditions.daySbt = '01'
        this.daySbtDisp = false
        this.dayDisp = false
        this.ymDisp = true
        this.yDisp = false
        this.eigyoshoDisp = false
        this.tokuisakiDisp = false
        this.seikyuTomeSbtDisp = false
        this.yoshasakiDisp = false
        this.unchinKakuteiSbtDisp = false
        this.hacchusakiDisp = false
        this.seikyusakiDisp = false
        this.shiharaisakiDisp = true
        this.seikyuTomeSbtReadOnly = true
      }
    },
    // 請求止めのReadOnlyが変わった時の対処
    seikyuTomeSbtReadOnly (newVal) {
      if (newVal) {
        this.conditions.seikyuTomeSbt = '01'
      } else {
        this.conditions.seikyuTomeSbt = '99'
      }
    }
  },
  computed: {
  },
  methods: {
    onXlsButtonClick: function () {
      if (!this.clientValidate()) { return }
      this.clearSummaryMessage()
      this.Effects.loadStart()
      let post = ''
      if (this.chohyoSbt === '1') {
        this.dispExcelNm = '得意先別売上集計表'
        post = '/api/v1/vwCD2bzmp0020/ExcelOutput'
      } else {
        return
      }
      this.HttpClient
        .requestFileByPost(post, this.conditions)
        .then((data) => {
          // aタグにファイル仕込んでClickする処理
          if (data.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            const elem = document.getElementById('xlsdownload')
            elem.href = window.URL.createObjectURL(blob)
            elem.download = this.dispExcelNm + '_' + ts + '.xlsx'
            elem.click()
            this.setInvalidSummaryMessage('COMI0007')
            this.Effects.loadComplete()
          } else {
            this.setInvalidSummaryMessage('COMI0101')
            this.Effects.loadComplete()
          }
        })

      this.xlsConditions.APIReceiveCsvLayoutKbn = this.APIReceiveCsvLayoutKbn
      this.HttpClient
        .requestFileByPost(this.xlsFunction, this.xlsConditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('xlsdownload')
          this.isXlsDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.download = this.xlsFileName + '_' + ts + '.xlsx'
          elem.click()
        })
    }
  }
}
